module.exports = __webpack_public_path__ + "img/alt-lead-img.5efa102a.jpg";